"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoardOfDirectors = void 0;
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const PreludeCard_1 = require("../prelude/PreludeCard");
const ResourceType_1 = require("../../ResourceType");
const SelectHowToPayDeferred_1 = require("../../deferredActions/SelectHowToPayDeferred");
const Size_1 = require("../render/Size");
const Tags_1 = require("../Tags");
const Resources_1 = require("../../Resources");
const SelectCard_1 = require("../../inputs/SelectCard");
class BoardOfDirectors extends PreludeCard_1.PreludeCard {
    constructor() {
        super({
            name: CardName_1.CardName.BOARD_OF_DIRECTORS,
            tags: [Tags_1.Tags.EARTH],
            resourceType: ResourceType_1.ResourceType.DIRECTOR,
            metadata: {
                cardNumber: 'P45',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.director(4);
                    b.preludeBox('action', (ce) => {
                        ce.vSpace();
                        ce.vSpace();
                        ce.action('Draw 1 prelude card: either discard it, or pay 12 M€ and remove one director resource from here to play it.', (eb) => {
                            eb.empty().startAction.megacredits(-12).director(1).colon().nbsp(Size_1.Size.TINY).prelude().asterix();
                        });
                        ce.vSpace();
                    });
                }),
                description: 'Add 4 director resources here.',
            },
        });
        this.resourceCount = 0;
    }
    play(player) {
        if (player.lastCardPlayed !== undefined && player.lastCardPlayed.name === CardName_1.CardName.DOUBLE_DOWN) {
            player.game.log('Resources from ${0} could not be added to ${1}', (b) => b.card(this).cardName(CardName_1.CardName.DOUBLE_DOWN));
            return undefined;
        }
        player.addResourceTo(this, { qty: 4, log: true });
        return undefined;
    }
    canAct(player) {
        if (player.canAfford(12) === false || this.resourceCount === 0) {
            this.warning = 'You will only be able to discard the drawn prelude card';
        }
        else {
            this.warning = undefined;
        }
        return true;
    }
    action(player) {
        const game = player.game;
        const card = game.dealer.dealPreludeCard(game);
        if (player.canAfford(12) === false || this.resourceCount === 0) {
            game.log('${0} was discarded as ${1} could not play it', (b) => b.card(card).player(player));
            game.dealer.discardPrelude(card);
            return undefined;
        }
        const message = `Select ${card.name} to play it for 12 M€ and one Director, or discard it`;
        return new SelectCard_1.SelectCard(message, 'Confirm', [card], (selectedCards) => {
            if (selectedCards.length === 1) {
                player.removeResourceFrom(this);
                game.defer(new SelectHowToPayDeferred_1.SelectHowToPayDeferred(player, 12, { title: 'Select how to pay for prelude', afterPay: () => {
                        if (card.canPlay === undefined || card.canPlay(player)) {
                            return player.playCard(card);
                        }
                        else {
                            game.log('${0} was discarded for 15 M€ as ${1} could not play it', (b) => b.card(card).player(player));
                            player.addResource(Resources_1.Resources.MEGACREDITS, 15, { log: true });
                            game.dealer.discardPrelude(card);
                            return undefined;
                        }
                    } }));
            }
            else {
                game.log('${0} discarded ${1}', (b) => b.player(player).card(card));
                game.dealer.discardPrelude(card);
            }
            return undefined;
        }, { min: 0, max: 1 });
    }
}
exports.BoardOfDirectors = BoardOfDirectors;
//# sourceMappingURL=BoardOfDirectors.js.map